module.exports = "/static/assets/b246d0b191ec6afb48f0989335ce47d0.png";